module.exports = __webpack_public_path__ + "img/RedPOS.6737fc32.png";